import { render } from "./TopicBrowserPanel.vue?vue&type=template&id=80f1f800&scoped=true"
import script from "./TopicBrowserPanel.vue?vue&type=script&lang=js"
export * from "./TopicBrowserPanel.vue?vue&type=script&lang=js"

import "./TopicBrowserPanel.vue?vue&type=style&index=0&id=80f1f800&lang=scss&scoped=true"
import "./TopicBrowserPanel.vue?vue&type=style&index=1&id=80f1f800&lang=scss"
script.render = render
script.__scopeId = "data-v-80f1f800"

export default script